import styled from 'styled-components';

export const DefinedBenefitContributionBannerStyled = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '4px 24px',
  borderRadius: 3,
  backgroundColor: '#E7F4E6',
  alignContent: 'center',
  position: 'fixed',
  top: '80px',
  zIndex: '1020',
  width: '900px',

  '@media (max-width: 1199px)': {
    top: '160px',
    width: '100%',
    maxWidth: '900px',
  },

  '@media (max-width: 990px)': {
    left: '0',
    maxWidth: '100%',
  },

  '@media (max-width: 743px)': {
    marginTop: '24px',
    position: 'static',
    maxWidth: '100%',
    flexFlow: 'column',
  },
});

export const DefinedBenefitContributionTableStyled = styled('div')({
  border: '1px solid #BBC1D0',
  borderRadius: '8px',
  padding: '24px',
  marginTop: '24px',
});

export const DefinedBenefitContributionSpacing = styled('div')({
  marginBottom: '40px',
  '@media (max-width: 1199px)': {
    marginBottom: '100px',
  },
  '@media (max-width: 743px)': {
    marginBottom: '0px',
  },
});

export const DefinedBenefitContributionLogoStyled = styled('div')({
  width: '48px',
});
